import { useEffect, useRef, useState } from "react";
import { printer } from "../../asset";
import { CustomButton, IDCard, PageHeader } from "../../components";
import { usePrint } from "../../util/hooks/usePrint";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useParams } from "react-router-dom";
import { Student } from "../../types/studentType";
import StudentApis from "../../api/studentApis";

export default function StudentIdCard() {
  const cardRef = useRef<HTMLDivElement | null>(null);
  const school = useSelector((state: RootState) => state.access.schoolBranch);

  const { id } = useParams();
  const [studentData, setStudentData] = useState<Student | null>(null);

  useEffect(() => {
    if (!id) return;

    StudentApis.getStudentById(Number(id)).then((res) => {
      if (res?.status === 1) {
        setStudentData(res.data);
      }
    });
  }, [id]);

  // PRINT
  const handlePrint = usePrint(cardRef, {
    documentTitle: "ID_Card",
  });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:justify-between md:items-center">
        <PageHeader title="STUDENT’S ID CARD" showBack />
        <div className="flex justify-end items-end gap-3">
          <CustomButton text="Edit details" color="bg-primary-500" />
          <CustomButton
            text="Print/Download"
            color="bg-success-600"
            icon={printer}
            onClick={handlePrint}
          />
        </div>
      </div>
      <div className="bg-white rounded-lg py-7 pb-14 w-full gap-9 flex flex-col justify-center items-center">
        <header className="flex flex-col gap-3 justify-center items-center">
          <h3 className="text-neutral-300 text-sm font-semibold">
            Create Student’s ID Card
          </h3>
          <p className="text-3xl font-semibold text-primary-600">
            Easily build and download ID Cards
          </p>
        </header>
        <div ref={cardRef} className="print-wrapper">
          <section className="grid md:grid-cols-2 gap-20 print-grid">
            <IDCard
              side="front"
              logo={school?.schoolBranchIcon}
              roleLabel="Student"
              roleGradient="linear-gradient(270deg, rgba(255, 255, 255, 0.50) 0%, var(--Primary-primary-50, #E9EFFD) 21.63%, var(--Primary-primary-300, #6D96F2) 40.38%, var(--Primary-primary-600, #225AD6) 59.13%, var(--Primary-primary-700, #1A46A7) 100%)"
              textColorClass="text-primary-600"
              name={studentData?.fullName}
              studentClass={studentData?.classSection || studentData?.academicCycle}
              image={studentData?.photoUrl}
            />

            <IDCard
              side="back"
              logo={school?.schoolBranchIcon}
              roleLabel="Student"
              textColorClass="text-primary-600"
              QRBorder="border-primary-600"
              motherName={studentData?.motherFullName}
              fatherName={studentData?.fatherFullName}
              motherPhone={studentData?.motherPhoneNumber}
              fatherphone={studentData?.fatherPhoneNumber}
              footerEmail={school?.emailAddress}
              schoolName={school?.schoolBranchName}
            />
          </section>
        </div>
      </div>
    </div>
  );
}
